export const trackableEvents = {
  SIGNUP: "Sign Up",
  LOGIN: "Login",
  LOGOUT: "Logout",
  ADD_FILTERS: "Add Filters",
  SUBMIT_INFO: "Submit Info",
  REQUEST_EMAIL: "Request Email",
  SEND_FEEDBACK: "Send Feedback",
  CHANGE_PASSWORD: "Change Password"
}